/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../molecules/fieldset/css/fieldset';
import '../../../molecules/form-element/css/form-element';
import '../../../molecules/form-actions/css/form-actions';
import './form.scss';
import './modifier/cms.scss';
import './modifier/no-padding.scss';
